import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { RoleType } from '@feature/security';

import { UserCreateRequest } from './UserTypes';

export const userCreateSchema = z.object({
  email: z.string().trim().email(),
  firstName: z.string().trim().min(1),
  lastName: z.string().trim().min(1),
  roles: z.array(z.nativeEnum(RoleType)).min(1),
});

export type UserCreateSchema = z.infer<typeof userCreateSchema>;

export const defaultUserCreateValues: DefaultValues<UserCreateSchema> = {
  email: '',
  firstName: '',
  lastName: '',
  roles: [],
};

export function toUserCreateRequest(values: UserCreateSchema): UserCreateRequest {
  return {
    email: values.email,
    firstName: values.firstName,
    lastName: values.lastName,
    roles: values.roles,
  };
}
